var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSplashBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 347,
    height: 400,
    viewBox: "0 0 347 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M247.586 390.179L264.609 373.136L281.632 390.179C279.397 392.417 276.743 394.192 273.822 395.404C270.901 396.615 267.77 397.238 264.609 397.238C261.448 397.238 258.317 396.615 255.396 395.404C252.475 394.192 249.822 392.417 247.586 390.179Z",
    stroke: "#E8E3D1",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M264.609 372.854V204.261",
    stroke: "#E8E3D1",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M85.846 25.7855V-33.8971H72.663V25.7855H85.846Z",
    fill: "#E8E3D1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72.663 65.3824V25.7855H59.48V65.3824H72.663Z",
    fill: "#E8E3D1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M85.846 125.066V65.3834H72.663V125.066H85.846Z",
    fill: "#E8E3D1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M98.054 65.947L120.629 124.583",
    stroke: "#E8E3D1",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.47801 65.947L29.053 124.583",
    stroke: "#E8E3D1",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M437.213 293.785H171.768C145.484 293.785 120.276 283.331 101.69 264.723C83.1039 246.115 72.6623 220.878 72.662 194.562V-266.315",
    stroke: "#E8E3D1",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M76.601 261.574L113.275 298.291",
    stroke: "#E8E3D1",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M58.264 279.932L94.938 316.65",
    stroke: "#E8E3D1",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.657 275.994L54.331 312.711",
    stroke: "#E8E3D1",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M21.59 316.649L58.264 353.366",
    stroke: "#E8E3D1",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M3.25303 335.007L39.927 371.725",
    stroke: "#E8E3D1",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6159 304.964L46.593 287.921L29.5701 304.964L46.593 322.007L63.6159 304.964Z",
    fill: "#E8E3D1"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M264.609 217.728C261.948 217.728 259.348 216.938 257.135 215.458C254.923 213.978 253.199 211.875 252.181 209.414C251.163 206.953 250.896 204.245 251.416 201.632C251.935 199.02 253.216 196.62 255.097 194.737C256.978 192.853 259.375 191.57 261.985 191.051C264.594 190.531 267.299 190.798 269.757 191.817C272.215 192.836 274.316 194.563 275.794 196.777C277.272 198.992 278.061 201.596 278.061 204.26C278.061 207.832 276.644 211.257 274.121 213.783C271.598 216.309 268.177 217.728 264.609 217.728Z",
    fill: "#E8E3D1"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M25.701 228.938C20.8263 228.938 16.0611 227.491 12.0079 224.779C7.95473 222.068 4.79562 218.214 2.93015 213.705C1.06467 209.196 0.576607 204.234 1.52762 199.448C2.47863 194.661 4.82603 190.264 8.27298 186.813C11.7199 183.362 16.1116 181.012 20.8926 180.06C25.6737 179.108 30.6294 179.596 35.133 181.464C39.6367 183.332 43.486 186.494 46.1942 190.552C48.9025 194.61 50.3481 199.381 50.3481 204.262C50.3481 210.806 47.7513 217.083 43.1291 221.71C38.5069 226.338 32.2378 228.938 25.701 228.938Z",
    fill: "#E8E3D1"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7021 213.724C23.8326 213.724 22.0051 213.169 20.4508 212.129C18.8964 211.089 17.6849 209.611 16.9695 207.882C16.2541 206.153 16.067 204.25 16.4317 202.414C16.7964 200.579 17.6966 198.893 19.0185 197.569C20.3403 196.246 22.0246 195.344 23.8581 194.979C25.6916 194.614 27.5921 194.802 29.3192 195.518C31.0463 196.234 32.5225 197.447 33.5611 199.003C34.5997 200.559 35.154 202.389 35.154 204.261C35.1538 206.77 34.1578 209.177 32.3853 210.952C30.6127 212.727 28.2088 213.724 25.7021 213.724V213.724Z",
    stroke: "#E8E3D1",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSplashBg);
export default __webpack_public_path__ + "static/media/splash-bg.12747b85a6ef21a30f6bed8ad3714227.svg";
export { ForwardRef as ReactComponent };